export const cardsValuesConvertNumber = {
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  j: 11,
  q: 12,
  k: 13,
  a: 14,
};
